import * as PIXI from 'pixi.js-legacy';

import InnerDropArea from '../InnerDropArea';

import DynamicProppingAncestor from '../DynamicProppingAncestor';
import geometry from '../util/geometry';
import project from '../util/project';
import tacHelpers from '../../state/tac/tacHelpers';
import constants from '../../settings/constants';

export default class Sidewall extends DynamicProppingAncestor {
  drawSideWall() {
    this.place();
    const { item } = this;
    const { outerSize, scaledVertices } = this.data;

    this.sideWallContainer = this.sideWallContainer || new PIXI.Container();

    const currentSpace = tacHelpers.getCurrentSpace(this.app.tac);

    const entireWall = project.outer({
      ...item,
      height: currentSpace.height,
    });

    this.sideWallSprite =
      this.sideWallSprite || new PIXI.Sprite(PIXI.Texture.WHITE);
    this.sideWallSprite.width = outerSize.width * this.ratio;
    this.sideWallSprite.x = 1; //can't explain, but looks better.
    this.sideWallSprite.y = -this.y;
    this.sideWallSprite.height =
      entireWall.height * this.ratio + scaledVertices[3][1];
    this.sideWallSprite.tint = 0xe0e0e0;

    this.skirt = this.skirt || new PIXI.Graphics();
    const skirtHeight = this.app.room.getSkirtHeight();
    const skirtPoints = [
      {
        x: 0,
        y: scaledVertices[0][1],
      },
      { x: 0, y: scaledVertices[0][1] - skirtHeight },
      {
        x: scaledVertices[5][0],
        y: scaledVertices[5][1] - skirtHeight,
      },
      {
        x: scaledVertices[5][0],
        y: scaledVertices[5][1],
      },
      {
        x: 0,
        y: scaledVertices[0][1],
      },
    ].map(point => {
      return new PIXI.Point(point.x, point.y);
    });

    this.skirt
      .clear()
      .beginFill(constants.RIGHT_SIDEWALL_SKIRT_COLOR)
      .drawPolygon(skirtPoints)
      .endFill();

    this.skirtEdge = this.skirtEdge || new PIXI.Graphics();
    this.skirtEdge
      .clear()
      .lineStyle(
        constants.SKIRT_EDGE_THICKNESS * this.ratio,
        constants.RIGHT_SIDEWALL_SKIRT_EDGE_COLOR
      )
      .moveTo(skirtPoints[1].x, skirtPoints[1].y)
      .lineTo(skirtPoints[2].x, skirtPoints[2].y);

    this.floorCrop = this.floorCrop || new PIXI.Graphics();

    const maskPoints = [
      {
        x: scaledVertices[5][0] - this.app.room.slopeWidth,
        y: scaledVertices[5][1] + this.app.room.slopeHeight,
      },
      {
        x: this.sideWallSprite.x + this.sideWallSprite.width,
        y: scaledVertices[5][1] + this.app.room.slopeHeight,
      },
      {
        x: this.sideWallSprite.x + this.sideWallSprite.width,
        y: scaledVertices[5][1],
      },
      {
        x: scaledVertices[5][0] - this.app.room.slopeWidth,
        y: scaledVertices[5][1] + this.app.room.slopeHeight,
      },
    ].map(point => {
      return new PIXI.Point(point.x, point.y);
    });

    this.floorCrop.clear().beginTextureFill().drawPolygon(maskPoints).endFill();

    !this.skirt.parent && this.sideWallContainer.addChild(this.skirt);
    !this.skirtEdge.parent && this.sideWallContainer.addChild(this.skirtEdge);
    !this.sideWallSprite.parent &&
      this.sideWallContainer.addChild(this.sideWallSprite);
    !this.floorCrop.parent && this.sideWallContainer.addChild(this.floorCrop);
    !this.sideWallContainer.parent && this.addChild(this.sideWallContainer);
  }

  draw() {
    this.interactive = false;

    const { item } = this;
    this.visible = !item.hidden;

    const { scaledVertices } = this.data;

    this.rightDropAreas = this.rightDropAreas || new PIXI.Container();
    this.rightDropAreas.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.rightDropAreas.parent) {
      this.addChild(this.rightDropAreas);
    }

    this.childrenContainer = this.childrenContainer || new PIXI.Container();
    this.childrenContainer.x = scaledVertices[4][0] - scaledVertices[0][0];

    if (!this.childrenContainer.parent) {
      this.addChild(this.childrenContainer);
    }

    if (item.x > 0) {
      // only for right sidewall
      this.drawSideWall();

      if (
        !this.options.wallResizerActive &&
        tacHelpers.isClothesRailConnected(this.app.tac, item)
      ) {
        this.sideWallContainer.alpha = 1;
        this.sideWallSprite.alpha = 0.5;
      } else {
        this.sideWallContainer.alpha = 0;
      }
    }

    this.drawChildren();
  }

  drawDropAreas(slots) {
    slots = slots.filter(slot => slot.parent.itemid === this.item.itemid);

    const localItem = {
      ...this.item,
      x: 0,
      y: 0,
    };

    slots.forEach(slot => {
      const localSlot = { ...slot, ...slot.local };

      if (
        geometry.extendsOutside(localSlot, localItem) &&
        localSlot.y < localItem.height
      ) {
        const width = localSlot.partnerSlot
          ? localSlot.partnerSlot.x + localSlot.partnerSlot.width - slot.x
          : localSlot.width;
        const sprite = new InnerDropArea({
          width: width * this.ratio,
          height: localSlot.height * this.ratio,
          ratio: this.ratio,
          slot: localSlot,
        });

        sprite.slot = localSlot;

        sprite.x = localSlot.x * this.ratio;
        sprite.y =
          (this.item.height - (localSlot.y + localSlot.height)) * this.ratio;

        this.rightDropAreas.addChild(sprite);
      }
    });
  }

  displayDropAreas(slot) {
    this.displayDropArea(this.rightDropAreas, slot);
  }

  eraseDropAreas() {
    this.rightDropAreas.removeChildren();
  }
}
